import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EnvironmentInjector,
    Input,
    OnDestroy,
    OnInit,
    ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { Subscription } from "rxjs";
import { TableResponse } from "../../_model/table-response/table-response";
import { TableService } from "../../service/table/table-service";
import { ClientStateService } from "../navbar/client-state.service";
import { Router } from "@angular/router";
import { Constants } from "../../_model/constants";
import { WorkOrderHistoryDialogComponent } from "../work-order-history-dialog/work-order-history-dialog.component";
import { History } from "../../_model/history-response/history";
import { ClientService } from "../../service/client.service";
import { animate, state, style, transition, trigger } from '@angular/animations';
import { LoginStateService } from "../../pages/login/login-state.service";
import { AcceptRejectDialogComponent } from "../accept-reject-dialog/accept-reject-dialog.component";
import { RejectDialogComponent } from "../reject-dialog/reject-dialog.component";
import { SnackbarService } from "../../service/snackbar.service";
import { UserService } from "../../service/user.service";
import { User } from "../../_model/user/user";
import { InvoiceDialogComponent } from "../invoice-dialog/invoice-dialog.component";
import { MatIconModule } from "@angular/material/icon";
import { CommonModule, DatePipe } from "@angular/common";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatTableModule } from "@angular/material/table";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { SingleInputFilterComponent } from "../single-input-filter/single-input-filter.component";
import { MultipleInputFilterComponent } from "../multiple-input-filter/multiple-input-filter.component";
import { TableDefinition } from "../../_model/table-response/table-definition";
import { MatChipsModule } from "@angular/material/chips";
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { PestInformationDialogComponent } from "../pest-information-dialog/pest-information-dialog.component";
import { environment } from "../../../environments/environment";

@Component({
    selector: "app-table",
    templateUrl: "./table.component.html",
    standalone: true,
    imports: [
        MatIconModule,
        MatChipsModule,
        CommonModule,
        MatTooltipModule,
        MatTableModule,
        MatPaginator,
        MatProgressSpinnerModule,
        SingleInputFilterComponent,
        MultipleInputFilterComponent,
        MatFormFieldModule,
        MatSelectModule,
        MatDialogModule,
        FormsModule,
        MatButtonModule,
        MatInputModule
    ],
    styleUrls: ["./table.component.scss"],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*', minHeight: "*" })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})
export class TableComponent implements OnInit, OnDestroy {
    @Input() tableService!: TableService;

    @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;

    tableData!: TableResponse;
    tableDisplayedColumns!: string[];
    expandableDisplayedColumns!: string[];
    columnTooltip!: string[];
    expandedElement!: TableResponse;
    length!: number;
    downloadPOSForm!: FormGroup;

    isLoadingResults = true;
    isLoadingData = false;
    isWorkOrderRoute = false;
    isAccordion = false;
    showVisitsAccordion = false;
    showWoAccordion = false;
    isVisits = false;
    isWorkOrders = false;
    textareaLength = 15;
    columns!: string[];
    clientSubscription!: Subscription;
    paginatorSubscription!: Subscription;

    selectedFilters!: FormGroup<any> | null;
    public history!: History[];
    public activeLabel!: string;
    viewPestInfoLinkBackendNameNA = Constants.viewPestInfoLinkBackendNameNA;
    environment = environment;

    constructor(
        private clientStateService: ClientStateService, private userService: UserService,
        private router: Router, private clientService: ClientService,
        private fb: FormBuilder, public dialog: MatDialog, private loginStateService: LoginStateService,
        private sbService: SnackbarService) { }

    ngOnInit() {
        // this.selectedFilters = null;
        // if (this.loginStateService.isVisits) {
        // console.log("ngonit",this.loginStateService.isVisits)
        // this.selectedFilters = JSON.parse(sessionStorage.getItem('setFilter'))
        // }
        this.isLoadingData = true;
        this.checkWorkOrderRoute();
        this.initializeTable(0, 100);
        this.clientSubscription =
            this.clientStateService.clientStateChanged$.subscribe(() => {
                this.paginator.firstPage();
                this.paginator.pageSize = 100;
                this.selectedFilters = null;
                this.checkWorkOrderRoute();
                this.initializeTableInStateChange(0, 100);
            });

        this.paginatorSubscription = this.paginator.page.subscribe((event) => {
            this.initializeTable(event.pageIndex, event.pageSize);
        });
    }

    onSelectedFilter(selectedFilter: FormGroup) {
        if (
            (selectedFilter.value &&
                selectedFilter.value.tableFilter &&
                selectedFilter.value.value) ||
            (selectedFilter &&
                typeof selectedFilter.value.multipleFilterarray != "undefined" &&
                selectedFilter.value.multipleFilterarray != null &&
                selectedFilter.value.multipleFilterarray.length != null &&
                selectedFilter.value.multipleFilterarray.length > 0)
        ) {
            this.selectedFilters = selectedFilter;
            sessionStorage.setItem('setFilter', JSON.stringify(selectedFilter.value));
        } else {
            this.selectedFilters = null;
        }
        this.paginator.pageSize = 100;
        this.paginator.firstPage();
        this.initializeTable(0, 100);
    }

    private initializeTableInStateChange(page: number, size: number) {
        this.isLoadingResults = true;
        this.isLoadingData = false;
        let user: User = this.userService.getUser();
        const filterFormGroup = this.selectedFilters || new FormGroup({});

        this.tableService.getTableData(filterFormGroup, user.brand, page, size).subscribe(
            (result) => {
                if (result.data.tablePagination && result.data.tablePagination.last) {
                    this.length = result.data.tableRows.length;
                } else {
                    this.length =
                        this.paginator.pageSize * (this.paginator.pageIndex + 1) + 1;
                }
                this.tableData = result;
                // this.tableDisplayedColumns = this.tableData.data.tableDefinitions.map(
                //   (c) => c.columnDef
                // );
                this.columnTooltip = this.tableData.data.tableDefinitions.filter(c => c.isAccordion == true).map(c => c.columnTooltip);
                this.tableDisplayedColumns = this.tableData.data.tableDefinitions.filter(c => c.isAccordion == false).map(c => c.columnDef);
                this.expandableDisplayedColumns = this.tableData.data.tableDefinitions.filter(c => c.isAccordion == true).map(c => c.header);
                this.isLoadingResults = false;
                this.isLoadingData = true;
            },
            () => (this.isLoadingResults = true)
        );
    }

    private initializeTable(page: number, size: number) {
        // console.log("table 1");
        this.isLoadingResults = true;
        // this.isVisits = true;
        if (this.loginStateService.isVisits == false && this.loginStateService.isWorkOrders == false) {
            let user: User = this.userService.getUser();
            const filterFormGroup = this.selectedFilters || new FormGroup({});

            this.tableService.getTableData(filterFormGroup, user.brand, page, size).subscribe(
                (result) => {
                    // console.log(result)
                    if (result.data.tablePagination && result.data.tablePagination.last) {
                        this.length = result.data.tableRows.length;
                        // console.log("if length")
                    } else {
                        this.length =
                            this.paginator.pageSize * (this.paginator.pageIndex + 1) + 1;
                        // console.log("else length")

                    }
                    this.tableData = result;
                    this.columnTooltip = this.tableData.data.tableDefinitions.filter(c => c.isAccordion == true).map(c => c.columnTooltip);
                    this.expandableDisplayedColumns = this.tableData.data.tableDefinitions.filter(c => c.isAccordion == true).map(c => c.header);
                    this.tableDisplayedColumns = this.tableData.data.tableDefinitions.filter(c => c.isAccordion == false).map(c => c.columnDef);
                    this.isLoadingResults = false;
                    this.isLoadingData = true;
                    this.loginStateService.isVisits = false;
                },
                () => (this.isLoadingResults = true)

            );
        }
        else if (this.loginStateService.isVisits == true) {
            this.isVisits = true;
            const workOrderId = this.loginStateService.workOrderId;
            let user: User = this.userService.getUser();
            this.tableService.getVisits(workOrderId, user.brand, 0, 100).subscribe((result) => {
                if (result.data.tablePagination && result.data.tablePagination.last) {
                    this.length = result.data.tableRows.length;
                } else {
                    this.length =
                        this.paginator.pageSize * (this.paginator.pageIndex + 1) + 1;
                }
                this.tableData = result;
                this.columnTooltip = this.tableData.data.tableDefinitions.filter(c => c.isAccordion == true).map(c => c.columnTooltip);
                this.expandableDisplayedColumns = this.tableData.data.tableDefinitions.filter(c => c.isAccordion == true).map(c => c.header);
                this.tableDisplayedColumns = this.tableData.data.tableDefinitions.filter(c => c.isAccordion == false).map(c => c.columnDef);
                this.isLoadingResults = false;
                this.isLoadingData = true;
                this.loginStateService.isVisits = true;
                // this.loginStateService.isWorkOrders = true;
                this.isVisits = false;
                this.loginStateService.workOrderId = null;
            },
            );
        }

        else if (this.loginStateService.isWorkOrders == true && this.loginStateService.isVisits == false) {
            this.isWorkOrders = true;
            const workOrderNumber = this.loginStateService.workOrderNumber;
            let user: User = this.userService.getUser();
            this.tableService.getWorkOrders(workOrderNumber, user.brand, 0, 100).subscribe((result) => {
                if (result.data.tablePagination && result.data.tablePagination.last) {
                    this.length = result.data.tableRows.length;
                } else {
                    this.length =
                        this.paginator.pageSize * (this.paginator.pageIndex + 1) + 1;
                }
                this.tableData = result;
                this.columnTooltip = this.tableData.data.tableDefinitions.filter(c => c.isAccordion == true).map(c => c.columnTooltip);
                this.expandableDisplayedColumns = this.tableData.data.tableDefinitions.filter(c => c.isAccordion == true).map(c => c.header);
                this.tableDisplayedColumns = this.tableData.data.tableDefinitions.filter(c => c.isAccordion == false).map(c => c.columnDef);
                this.isLoadingResults = false;
                this.isLoadingData = true;
                this.loginStateService.isWorkOrders = true;
                // this.loginStateService.isVisits = false;
                this.isWorkOrders = false;
                this.loginStateService.workOrderNumber = null;
            },
            );
        }
        // this.loginStateService.isVisits = false;

    }

    isArray = () => {
        if (this.tableDisplayedColumns.includes('acceptOrReject')) {
            return true;
        }
        else {
            return false;
        }
    }

    showVisits(row: any) {
        this.isVisits = true;
        this.loginStateService.isVisits = true;
        this.loginStateService.isWorkOrders = false;
        this.loginStateService.workOrderId = row.workOrderNumber;
        this.router.navigate(['/visits']);
        sessionStorage.setItem('activeLabel', JSON.stringify('Visits'));
        // this.loginStateService.activeLabel = JSON.parse(sessionStorage.getItem('activeLabel'));
        const activeLabelFromSession = sessionStorage.getItem('activeLabel');
        if (activeLabelFromSession) {
            this.loginStateService.activeLabel = JSON.parse(activeLabelFromSession);
        } else {
            // Handle the null case, e.g., by setting a default value
            this.loginStateService.activeLabel = 'Visits'; // Or another default
        }
    }

    showWorkOrders(row: any) {
        this.isWorkOrders = true;
        // this.loginStateService.isVisits = false;
        this.loginStateService.isWorkOrders = true;
        this.loginStateService.workOrderNumber = row.workOrderNumber;
        this.router.navigate(['/']);
        sessionStorage.setItem('activeLabel', JSON.stringify('Work Orders'));
        // this.loginStateService.activeLabel = JSON.parse(sessionStorage.getItem('activeLabel'));

        const activeLabelFromSession = sessionStorage.getItem('activeLabel');
        if (activeLabelFromSession) {
            this.loginStateService.activeLabel = JSON.parse(activeLabelFromSession);
        } else {
            // Handle the null case, e.g., by setting a default value
            this.loginStateService.activeLabel = 'Work Orders'; // Or another default
        }
    }

    checkWorkOrderRoute(): void {
        if (this.router.url === "/" || this.router.url === "/visits") {
            this.showWoAccordion = true;
            this.showVisitsAccordion = true;
            this.isWorkOrderRoute = true;
            this.isAccordion = true;
        }
        if (this.router.url === "/visits") {
            this.isWorkOrderRoute = true;
            sessionStorage.setItem('activeLabel', JSON.stringify('Visits'));
            // this.activeLabel = JSON.parse(sessionStorage.getItem('activeLabel'));

            const activeLabelFromSession = sessionStorage.getItem('activeLabel');

            if (activeLabelFromSession) {
                // If activeLabelFromSession is not null, it's safe to parse it.
                this.loginStateService.activeLabel = JSON.parse(activeLabelFromSession);
            } else {
                // Handle the null case. You might set a default value or do nothing.
                this.loginStateService.activeLabel = 'Default Value'; // Or whatever your default should be
            }

            this.isAccordion = true;
            this.showVisitsAccordion = true;
            this.showWoAccordion = false;
        }
        if (this.router.url === "/") {
            this.showWoAccordion = true;
            this.showVisitsAccordion = false;
            this.isAccordion = true;
        }
        //   else {
        //   this.isWorkOrderRoute = false;
        // }
    }

    ngOnDestroy(): void {
        this.clientSubscription.unsubscribe();
        this.paginatorSubscription.unsubscribe();
    }

    // customTB(item: any, index: number) {
    //   return `${item}-${index}`;
    // }

    customTB(index: number, item: TableDefinition): string {
        return item.columnDef;
    }


    checkIsPosLink(row: any) {
        if ((row.downloadPOSLink == Constants.downloadPOSLinkBackendName)) {
            return true;
        } else {
            return false;
        }
    }

    checkIsVisitPosLink(row: any) {
    if (row.downloadPOSLink == Constants.downloadPOSLinkBackendNameNA) {
      return false;
    } else if (row.downloadPOSLink == Constants.downloadPOSLinkBackendName) {
            return true;
        } else {
            return false;
        }
    }
    checkIsInvoiceLink(row: any) {
        if ((row.downloadInvoiceLink == Constants.downloadInvoiceLinkBackendName)) {
            return true;
        } else {
            return false;
        }
    }

    checkIsNotDownloadLink(text: any): Boolean {
        if ((text == Constants.downloadPOSLinkBackendName) || (text == Constants.downloadInvoiceLinkBackendName)) {
            return false;
        } else {
            return true;
        }
    }

    checkIsInvoicePopUpLink(row: any) {
        if ((row.invoicePopupLink == Constants.InvoicePopUpBackendName)) {
            return true;
        } else {
            return false;
        }
    }

    downloadPOSLogic(row: any) {
        this.isLoadingResults = true;
        let user: User = this.userService.getUser();
        this.tableService
            .downloadPOS(
                row.workOrderId,
                row.workOrderNumber, "", "", user.brand
            )
            .subscribe((result) => {
                if (result.data.errorMsg == "") {
                    this.downloadPdf(result.data.fileContent, result.data.fileName);
                    this.initializeTable(0, 100);
                } else {
                    alert(result.data.errorMsg);
                    this.initializeTable(0, 100);
                }
            });
    }

    downloadPOSVisitLogic(row: any) {
        //console.log(row);
        this.isLoadingResults = true;
        let user: User = this.userService.getUser();
        this.tableService
            .downloadVisitPOS(
                row.workOrderId,
                row.workOrderNumber, row.visitId, row.visitState, user.brand
            )
            .subscribe((result) => {
                if (result.data.errorMsg == "") {
                    this.downloadPdf(result.data.fileContent, result.data.fileName);
                    this.initializeTable(0, 100);
                } else {
                    alert(result.data.errorMsg);
                    this.initializeTable(0, 100);
                }
            });
    }

    downloadInvoiceLogic(row: any) {
        this.isLoadingResults = true;
        let user: User = this.userService.getUser();
        this.tableService
            .getInvoice(
                row.accountNumber,
                row.workOrderNumber, user.brand
            )
            .subscribe((result) => {
                if (result.data.errorMsg == "") {
                    this.downloadPdf(result.data.fileContent, result.data.fileName);
                    this.initializeTable(0, 100);
                } else {
                    alert(result.data.errorMsg);
                    this.initializeTable(0, 100);
                }
            });
    }

    openHistory(row: any, evt: MouseEvent): void {
        const target = new ElementRef(evt.currentTarget);
        if (row.workOrderId) {


            this.tableService.workOrderHistory(row.workOrderId, 0, 100).subscribe(
                (result) => {
                    this.dialog.open(WorkOrderHistoryDialogComponent, {
                        minWidth: '65%',
                        minHeight: '50%',
                        maxWidth: '70vw',
                        data: { history: result, trigger: target, item: row.workOrderNumber }
                    });
                },
                () => (this.isLoadingResults = true)

            );
        }
    }

    openPestInformation(row: any, evt: MouseEvent): void {
        const target = new ElementRef(evt.currentTarget);
        if (row.workOrderNumber) {


            this.tableService.pestInformation(row.workOrderNumber, 0, 100).subscribe(
                (result) => {
                    this.dialog.open(PestInformationDialogComponent, {
                        minWidth: '60%',
                        minHeight: '50%',
                        maxWidth: '80vw',
                        data: { pestInformation: result, trigger: target, item: row.workOrderNumber }
                    });
                },
                () => (this.isLoadingResults = true)

            );
        }
    }

    openInvoice(row: any, evt: MouseEvent): void {
        const target = new ElementRef(evt.currentTarget);
        if (row.workOrderNumber) {


            this.tableService.invoicePopUp(row.workOrderNumber, 0, 100).subscribe(
                (result) => {
                    this.dialog.open(InvoiceDialogComponent, {
                        minWidth: '60%',
                        minHeight: '50%',
                        maxWidth: '80vw',
                        data: { invoice: result, trigger: target, item: row.workOrderNumber }
                    });
                },
                () => (this.isLoadingResults = true)

            );
        }
    }

    accept(row: any, evt: MouseEvent, dataIndex: any): void {
        let i = dataIndex;
        let data = row.workOrderNumber;
        const dialogRef = this.dialog.open(AcceptRejectDialogComponent, {
            minWidth: '20%',
            minHeight: '0%',
            data: data
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.isLoadingResults = true;
                this.tableService.acceptWO(row.workOrderNumber).subscribe((result) => {
                    this.tableData.data.tableRows.forEach((obj, dataIndex) => {
                        if (obj.workOrderNumber === row.workOrderNumber) {
                            this.tableData.data.tableRows[dataIndex] = result.data.tableRows[0];
                            this.tableData.data.tableRows = [...this.tableData.data.tableRows];
                            if (this.tableData.data.tableRows[dataIndex].status == "REJECTED") {
                                this.sbService.openSnackBar(`The ${row.workOrderNumber} callout has been REJECTED ${this.tableData.data.tableRows[dataIndex].statusText}`, 'Close');
                            }
                            else if (obj.status == this.tableData.data.tableRows[dataIndex].status) {
                                this.sbService.openSnackBar(`The ${row.workOrderNumber} callout status has not changed ${this.tableData.data.tableRows[dataIndex].statusText}`, 'Close');
                            }
                            else {
                                this.sbService.openSnackBar(`The ${row.workOrderNumber} callout has been ACCEPTED successfully`, 'Close');
                            }
                        }
                    });

                    this.isLoadingResults = false;
                });
            }

        });
        const target = new ElementRef(evt.currentTarget);

    }


    reject(row: any, evt: MouseEvent, dataIndex: any): void {
        let i = dataIndex;
        let data = row.workOrderNumber;
        const dialogRef = this.dialog.open(RejectDialogComponent, {
            minWidth: '20%',
            minHeight: '0%',
            data: data
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.isLoadingResults = true;
                this.tableService.rejectWO(row.workOrderNumber).subscribe((result) => {
                    this.tableData.data.tableRows.forEach((obj, dataIndex) => {
                        if (obj.workOrderNumber === row.workOrderNumber) {
                            this.tableData.data.tableRows[dataIndex] = result.data.tableRows[0];
                            this.tableData.data.tableRows = [...this.tableData.data.tableRows];
                            if (this.tableData.data.tableRows[dataIndex].status == "REJECTED") {
                                this.sbService.openSnackBar(`The ${row.workOrderNumber} callout has been REJECTED successfully`, 'Close');
                            }
                            else if (obj.status == this.tableData.data.tableRows[dataIndex].status) {
                                this.sbService.openSnackBar(`The ${row.workOrderNumber} callout status has not changed ${this.tableData.data.tableRows[dataIndex].statusText}`, 'Close');
                            }
                        }
                    });

                    this.isLoadingResults = false;
                });
            }
        });
        const target = new ElementRef(evt.currentTarget);

    }


    downloadPdf(base64String: string, fileName: string) {
        const source = `data:application/pdf;base64,${base64String}`;
        const link = document.createElement("a");
        link.href = source;
        link.download = `${fileName}.pdf`;
        link.click();
    }
}
